export const SELECT_DEALER_FLYOUT_IMG = {
  src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20231102-0e19b-fccd0?hei=110',
  alt: 'Select Dealer'
};

export const SELECT_DEALER_FLYOUT_MOBILE_IMG = {
  src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20250507-e9c3e-c6802?hei=110',
  alt: 'Select Dealer'
};

export const ALP_SELECT_DEALER_FLYOUT_SHOWN = 'ALP_SELECT_DEALER_FLYOUT_SHOWN';

export const NO_SERVICE_INSIGHTS_IMG =
  'https://caterpillar.scene7.com/is/image/Caterpillar/CM20241115-93833-7095b';

export const ECOMMERCE_DEVELOPMENT_ROOT = '/webapp/wcs/stores/servlet';
export const HEADLESS_CATEGORY_PAGE_BASE_PATH = 'category';
